import { ENTITY_COMMAND_TYPE, ListControlRedifinitionDataType } from '@types'

export enum REDIFINITION_DATA_TYPE {
  ACTIONS = 'actions',
  COMMANDS = 'commands',
}

export const hasRedifinitionByDataType = (
  data: ListControlRedifinitionDataType | undefined,
  dataType: REDIFINITION_DATA_TYPE,
  commandTypes?: ENTITY_COMMAND_TYPE[]
) => {
  const connection = data?.redifinitions?.length ? data.redifinitions[0] : null

  if (!connection) {
    return false
  }

  if (commandTypes?.length) {
    const commandByType = connection[dataType].filter((cmd: any) => commandTypes.includes(cmd.type))

    return Boolean(commandByType.length)
  }

  return Boolean(connection[dataType].length)
}
